// redux/Overrides/reducer.js

import {
    FETCH_OVERRIDES_SUCCESS,
    FETCH_OVERRIDES_FAILURE,
    FETCH_OVERRIDE_SUCCESS,
    FETCH_OVERRIDE_FAILURE,
    CREATE_OVERRIDE_SUCCESS,
    CREATE_OVERRIDE_FAILURE,
    UPDATE_OVERRIDE_SUCCESS,
    UPDATE_OVERRIDE_FAILURE,
    DELETE_OVERRIDE_SUCCESS,
    DELETE_OVERRIDE_FAILURE,
} from "./types";

const initialState = {
    overrides: [],
    override: null,
    error: "",
};

export function overridesReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_OVERRIDES_SUCCESS:
            return {
                ...state,
                overrides: action.payload,
                error: "",
            };
        case FETCH_OVERRIDES_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case FETCH_OVERRIDE_SUCCESS:
            return {
                ...state,
                override: action.payload,
                error: "",
            };
        case FETCH_OVERRIDE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case CREATE_OVERRIDE_SUCCESS:
            return {
                ...state,
                overrides: [...state.overrides, action.payload],
                error: "",
            };
        case CREATE_OVERRIDE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case UPDATE_OVERRIDE_SUCCESS:
            return {
                ...state,
                overrides: state.overrides.map((override) =>
                    override._id === action.payload._id ? action.payload : override
                ),
                error: "",
            };
        case UPDATE_OVERRIDE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case DELETE_OVERRIDE_SUCCESS:
            return {
                ...state,
                overrides: state.overrides.filter((override) => override._id !== action.payload),
                error: "",
            };
        case DELETE_OVERRIDE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}
